module.exports = __webpack_public_path__ + "static/media/poster1.9c18a7dc.png";